// Converts square feet to square meters
export function sqftToSqm(sqft) {
  if (typeof sqft !== 'number') return 0;
  return +(sqft * 0.092903).toFixed(2);
}
export function mapUserDataToReferredBy(loginResponse) {
  return {
    id: loginResponse.userId,
    name: loginResponse.fullName,
    phone: loginResponse.phoneNumber,
    email: loginResponse.email,
    userName: loginResponse.userName,
    fullName: loginResponse.fullName,
    branch: loginResponse.branchId,
  };
}
function mapPropertyData(data) {
  if (!data) return null;
  return {
    name: data.property?.property_name,
    id: data.propertyId,
    city: data.property?.city?.lookupItemName,
  };
}
function mapUnitData(data) {
  if (!data) {
    return null;
  }
  const operationName = data.unit?.operation_type?.lookupItemName || '';
  let operationType = null;

  if (operationName === 'SaleAndRent') {
    operationType = 'Sale';
  } else if (operationName === 'Sale' || operationName === 'Rent') {
    operationType = operationName;
  }

  return {
    id: data.unitId,
    name: data.unit?.unit_ref_no,
    type: 1,
    operationType: operationType,
    propertyId: data.unit?.property_name?.id || null,
    saleType: data.unit?.sale_type?.lookupItemName || null,
  };
}

function mapContact(contactData) {
  const { contact } = contactData;
  const id = contactData.id;
  const name =
    contact.company_name ?? [contact.first_name, contact.last_name].join(' ');
  const mobile =
    contact.mobile?.phone ??
    contact.landline_number?.phone ??
    (contactData.details?.find((d) => d.title === 'mobile')?.value !== 'N/A'
      ? contactData.details.find((d) => d.title === 'mobile')?.value
      : null);
  const email =
    contact.email_address?.email ??
    contact.general_email?.email ??
    (contactData.details?.find((d) => d.title === 'email')?.value !== 'N/A'
      ? contactData.details.find((d) => d.title === 'email')?.value
      : null);

  return {
    id,
    name,
    type: contact.contact_type_id,
    mobile,
    email_address: email,
    contact_image: null,
  };
}

export const mapOwnerLeadDataToPostDto = (lead) => {
  return {
    leadJson: {
      lead: {
        lead_operation: lead.leadOperation,
        notesextra_requirements: lead.extraNotes,
        is_mortgage: lead.isMortgage ? 'Yes' : 'No',
        country: lead.country,
        city: lead.city,
        district: lead.district,
        community: lead.community,
        sub_community: lead.subCommunity,
        saleType: lead.saleType,
        property_name: mapPropertyData(lead.property),
        unit_ref_number: mapUnitData(lead.unit),
        contact_name: mapContact(lead.contact),
        lead_category: 'Owner',
        referredby: lead.referredBy,
        status: lead.status,
        lead_stage: lead.leadStage,
        method_of_contact: lead.methodOfContact,
        data_completed: 50,
        lead_type_id: 1,
        lead_type : lead.leadOwnerType
      },
    },
    isForAutoRotation: true,
  };
};

export const mapSeekerLeadDataToPostDto = (lead) => {
  return {
    leadJson: {
      lead: {
        lead_operation: lead.leadOperation,
        notesextra_requirements: lead.extraNotes,
        country: lead.country,
        city: lead.city,
        district: lead.district,
        community: lead.community,
        sub_community: lead.subCommunity,
        propertyunit_type: lead.unitType,
        property_name: mapPropertyData(lead.property),
        unit_ref_number: mapUnitData(lead.unit),
        contact_name: mapContact(lead.contact),
        lead_category: 'Seeker',
        referredby: lead.referredBy,
        status: lead.status,
        lead_stage: lead.leadStage,
        method_of_contact: lead.methodOfContact,
        bathrooms: lead.bathrooms.map((e) =>
          typeof e.id === 'number' ? e.id.toString() : e.id
        ),
        bedrooms: lead.bedrooms.map((e) =>
          typeof e.id === 'number' ? e.id.toString() : e.id
        ),
        size_sqft: [lead.sizeFrom, lead.sizeTo],
        size_sqm: [sqftToSqm(lead.sizeFrom), sqftToSqm(lead.sizeTo)],
        budget: [lead.budgetFrom, lead.budgetTo],
        view: lead.views,
        fitting_and_fixtures: lead.fittingFixtures,
        developer: lead.developer,
        data_completed: 32,
        lead_type_id: 2,
        operation_type: lead.operationType,
      },
    },
    isForAutoRotation: true,
  };
};
